import { render, staticRenderFns } from "./EditBreakpoints.vue?vue&type=template&id=61f2af4d&"
import script from "./EditBreakpoints.vue?vue&type=script&lang=ts&"
export * from "./EditBreakpoints.vue?vue&type=script&lang=ts&"
import style0 from "./EditBreakpoints.vue?vue&type=style&index=0&id=61f2af4d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports